import {
  MonitoringUpdateRatePlanLayer,
  MonitoringUpdateRatePlaneFieldsType
} from '../../types/monitoringUpdate'
import InputBoxValuesRatePlaneMenu from './InputBoxValuesRatePlaneMenu'

interface RowBoxValuesRatePlaneMenuProps {
  selectedRatePlaneRowMenu: MonitoringUpdateRatePlaneFieldsType
  dataRatePlane: MonitoringUpdateRatePlanLayer
  range: 'TWO_WEEKS' | 'MONTH'
  weekendIndexes: number[]
}
export default function RowBoxValuesRatePlaneMenu({
  selectedRatePlaneRowMenu,
  dataRatePlane,
  range,
  weekendIndexes
}: RowBoxValuesRatePlaneMenuProps) {
  switch (selectedRatePlaneRowMenu) {
    case 'default':
      return (
        <>
          {dataRatePlane.dataForEachDate.map((data, index) => (
            <InputBoxValuesRatePlaneMenu
              key={index}
              data={{ status: data.status, time: data.time }}
              range={range}
              index={index}
              weekendIndexes={weekendIndexes}
            />
          ))}
        </>
      )
    case 'rates':
      return (
        <>
          {dataRatePlane.dataForEachDate.map((data, index) => (
            <InputBoxValuesRatePlaneMenu
              key={index}
              data={data.rates}
              range={range}
              index={index}
              weekendIndexes={weekendIndexes}
            />
          ))}
        </>
      )
    case 'restrictions':
      return (
        <>
          {dataRatePlane.dataForEachDate.map((data, index) => (
            <InputBoxValuesRatePlaneMenu
              key={index}
              data={data.restrictions}
              range={range}
              index={index}
              weekendIndexes={weekendIndexes}
            />
          ))}
        </>
      )
    default:
      return <div />
  }
}
